import {initBannerSlider} from "../swiper/swiper";

const classPrefix = 'call-us'
const dataPrefix = 'data-call-us'
const $container = document.querySelector(`[${dataPrefix}]`)

if ($container) {
    callUs()
}
export function callUs() {


}
